import React, {
  useMemo,
} from 'react';
import { Menu } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import {
  Switch, Route, useRouteMatch, useLocation, Link,
} from 'react-router-dom';
import {
  Other,
} from 'simplydo/interfaces';
import util from 'utils/utils';

import AssessmentsDashboard from './AssessmentsDashboard';
import YourAssessments from './YourAssessments';
import Assignment from './Assignment';

type IChallengeAssessments = {
  challenge: Other.IChallenge,
  getAssignedAssessments: () => void,
  myAssignedAssessments: Other.IIdeaAssignment[],
  setMyAssignedAssessments: (assessments: Other.IIdeaAssignment[]) => void,
  demoingTour?: string,
}

const ChallengeAssessments = (props: IChallengeAssessments) => {
  const user = useSelector((state: {user: Other.IUserMe | null}) => state?.user);
  const canManage = useMemo(() => util.canManageChallenge(user, props.challenge), [user, props.challenge]);
  const { path } = useRouteMatch();
  const { pathname } = useLocation();
  const challengeId = props?.challenge?._id;

  return (
    <div>
      {(canManage)
        ? (
          <Menu pointing secondary>
            <Menu.Item
              content='Dashboard'
              as={Link}
              to={`/challenges/${challengeId}/assessments`}
              active={pathname === `/challenges/${challengeId}/assessments`}
            />
            <Menu.Item
              content='Assignment'
              as={Link}
              to={`/challenges/${challengeId}/assessments/assignment`}
              active={pathname === `/challenges/${challengeId}/assessments/assignment`}
            />
            {props.myAssignedAssessments?.length
              ? (
                <Menu.Item
                  content='Your assigned assessments'
                  as={Link}
                  to={`/challenges/${challengeId}/assessments/assigned`}
                  active={pathname === `/challenges/${challengeId}/assessments/assigned`}
                />
              ) : null
            }
          </Menu>
        ) : null
      }
      <Switch>
        <Route
          exact
          path={path}
        >
          {canManage
            ? (
              <AssessmentsDashboard {...props} />
            ) : (
              <YourAssessments {...props} />
            )
          }
        </Route>
        <Route
          path={`${path}/assignment`}
        >
          {canManage
            ? (
              <Assignment {...props} />
            ) : (
              <YourAssessments {...props} />
            )
          }
        </Route>
        <Route
          path={`${path}/assigned`}
        >
          <YourAssessments {...props} />
        </Route>
      </Switch>
    </div>
  );
};

export default ChallengeAssessments;
